import { render } from "./InvoiceModal.vue?vue&type=template&id=33b070ad&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"

import "./InvoiceModal.vue?vue&type=style&index=0&id=33b070ad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b070ad"]])

export default __exports__